import {useDispatch, useSelector} from 'react-redux';
import {Store} from 'src/types/store';
import {useCallback} from 'react';
import {closeModal, openModal} from 'shared/actions/modal';

export interface UseModalState {
  open: () => void;
  close: () => void;
  closeAndOpen: (modalId: string) => void;
  isOpen: boolean;
}

/**
 * Use this hook to control a modals state
 * @param type Modal type
 */
export function useModal(type: string): UseModalState {
  const isOpen = useSelector<Store, boolean>((state) => state.modal[type] || false);
  const dispatch = useDispatch();
  return {
    isOpen,
    open: useCallback(() => dispatch(openModal(type)), [type, dispatch]),
    close: useCallback(() => dispatch(closeModal(type)), [type, dispatch]),
    closeAndOpen: useCallback(
      (modalId: string) => {
        dispatch(closeModal(type));
        dispatch(openModal(modalId));
      },
      [type, dispatch]
    ),
  };
}
